import styled from 'styled-components';
import { mt } from '@lendi-ui/spacing';

export const AccompanimentContainer = styled.div`
  display: flex;
  ${mt('xxxs')}
`;
